import React from "react";
import { Card, Table } from "react-bootstrap";

const SearchByBudgetComponent = () => {
  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h5>Search By Budget</h5>
        <button
          className="btn btn-primary"
          text-align="center"
          style={{ height: 30, width: 80, lineHeight: "50%" }}
        >
          Reset
        </button>
      </div>
      <Card style={{ maxHeight: 300 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <select
            name="Any Theme"
            id="Any Theme"
            style={{ width: "100%", height: "2em", border: "0px" }}
          >
            <option value="beach">Sector</option>
            <option value="saab">Saab</option>
            <option value="opel">Opel</option>
            <option value="audi">Audi</option>
          </select>
          <select
            name="Any Theme"
            id="Any Theme"
            style={{ width: "100%", height: "2em", border: "0px" }}
          >
            <option value="beach">Type</option>
            <option value="saab">Saab</option>
            <option value="opel">Opel</option>
            <option value="audi">Audi</option>
          </select>

          <select
            name="Any Theme"
            id="Any Theme"
            style={{ width: "100%", height: "2em", border: "0px" }}
          >
            <option value="beach">Period</option>
            <option value="saab">Saab</option>
            <option value="opel">Opel</option>
            <option value="audi">Audi</option>
          </select>
          <select
            name="Any Theme"
            id="Any Theme"
            style={{ width: "100%", height: "2em", border: "0px" }}
          >
            <option value="beach">Duration</option>
            <option value="saab">Saab</option>
            <option value="opel">Opel</option>
            <option value="audi">Audi</option>
          </select>
          <select
            name="Any Theme"
            id="Any Theme"
            style={{ width: "100%", height: "2em", border: "0px" }}
          >
            <option value="beach">Budget</option>
            <option value="saab">Saab</option>
            <option value="opel">Opel</option>
            <option value="audi">Audi</option>
          </select>
        </div>
        <Table responsive>
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 1,
              fontSize: "12px",
              backgroundColor: "white",
            }}
          >
            <tr>
              <th>Package Name</th>
              <th>Nights</th>
              <th>Price (Per Pax)</th>
            </tr>
          </thead>
          <tbody
            style={{
              fontSize: "12px",
              cursor: "pointer",
            }}
          >
            <tr>
              <td>Experience Madame Tussauds New Delhi</td>
              <td>0N</td>
              <td>₹ 450</td>
            </tr>
            <tr>
              <td>A Camping tour to Rishikesh</td>
              <td>1N</td>
              <td>₹ 3500</td>
            </tr>
            <tr>
              <td>Rann Utsav Festival</td>
              <td>1N</td>
              <td>₹ 4250</td>
            </tr>
            <tr>
              <td>Peaceful Amritsar</td>
              <td>1N</td>
              <td>₹ 4250</td>
            </tr>
            <tr>
              <td>Short Break to Imagica</td>
              <td>1N</td>
              <td>₹ 4250</td>
            </tr>
            <tr>
              <td>Mata Vaishno Devi</td>
              <td>1N</td>
              <td>₹ 4250</td>
            </tr>
            <tr>
              <td>Kathmandu Delights</td>
              <td>1N</td>
              <td>₹ 4250</td>
            </tr>
          </tbody>
        </Table>
      </Card>
    </>
  );
};

export default SearchByBudgetComponent;
